import React, { Component } from "react";
import { connect } from "react-redux";
import { createMeme } from "../actions";
import MemeItem from "./MemeItem";
import MyMemes from "./MyMemes";
import { Form, FormGroup, FormControl, FormLabel, Container, Row, Col, Card } from "react-bootstrap";
import "../styles/index.css";

class App extends Component {
  constructor() {
    super();

    this.state = {
      memeLimit: 10,
      text0: "",
      text1: "",
      searchTerm: "",
      selected: null,
      creating: false,
      error: false,
    };
  }

  generate = () => {
    const { selected, text0, text1, creating } = this.state;
    if (!selected || creating) return;
    this.setState({ creating: true, error: false });
    this.props
      .createMeme({ template_id: selected.id, text0, text1 })
      .then(() => this.setState({ creating: false }))
      .catch(() => this.setState({ creating: false, error: true }));
  };

  handleSearch = (event) => {
    this.setState({ searchTerm: event.target.value.toLowerCase() });
  };

  filterMemes = () => {
    if (!this.state.searchTerm) {
      return this.props.memes.slice(0, this.state.memeLimit);
    }
    
    return this.props.memes
      .filter(meme => meme.name.toLowerCase().includes(this.state.searchTerm))
      .slice(0, this.state.memeLimit);
  };

  render() {
    const { selected, text0, text1, creating, error } = this.state;
    return (
      <Container fluid className="meme-container">
        <Row className="header-section mb-4 mx-0">
          <Col>
            <h1 className="title">Meme Generator</h1>
            <p className="subtitle">Create and share your favorite memes!</p>
          </Col>
        </Row>

        <Row className="mb-4">
          <Col lg={7} className="mb-4 mb-lg-0">
            <Card className="templates-card">
              <Card.Body>
                <Card.Title>1. Choose a Template</Card.Title>
                <FormGroup className="mb-3">
                  <FormControl
                    type="search"
                    placeholder="Search templates by name..."
                    onChange={this.handleSearch}
                  />
                </FormGroup>
                {this.props.memes.length === 0 && (
                  <p className="text-muted text-center">Loading templates…</p>
                )}
                <div className="meme-templates-container">
                  {this.filterMemes().map((meme) => (
                    <MemeItem
                      key={meme.id}
                      meme={meme}
                      selected={selected && selected.id === meme.id}
                      onSelect={(m) => this.setState({ selected: m, error: false })}
                    />
                  ))}
                </div>
                {this.props.memes.length > this.state.memeLimit && !this.state.searchTerm && (
                  <button
                    type="button"
                    className="load-more-button"
                    onClick={() => this.setState({ memeLimit: this.state.memeLimit + 10 })}
                  >
                    Load More Templates
                  </button>
                )}
              </Card.Body>
            </Card>
          </Col>
          <Col lg={5}>
            <div className="sticky-panel">
            <Card className="text-input-card mb-4">
              <Card.Body>
                <Card.Title>2. Add Your Text</Card.Title>
                <Form onSubmit={(e) => e.preventDefault()}>
                  <Row>
                    <Col md={6}>
                      <FormGroup className="mb-3">
                        <FormLabel>Top Text</FormLabel>
                        <FormControl
                          type="text"
                          placeholder="Enter top text..."
                          disabled={!selected}
                          value={this.state.text0}
                          onChange={(event) => this.setState({ text0: event.target.value })}
                        />
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup className="mb-3">
                        <FormLabel>Bottom Text</FormLabel>
                        <FormControl
                          type="text"
                          placeholder="Enter bottom text..."
                          disabled={!selected}
                          value={this.state.text1}
                          onChange={(event) => this.setState({ text1: event.target.value })}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  {!selected && <p className="text-muted mb-0">Pick a template first.</p>}
                </Form>
              </Card.Body>
            </Card>

            <Card className="preview-card">
              <Card.Body>
                <Card.Title>3. Preview &amp; Generate</Card.Title>
                {selected ? (
                  <>
                    <div className="meme-preview">
                      <img src={selected.url} alt={selected.name} />
                      {text0 && <span className="preview-text preview-top">{text0}</span>}
                      {text1 && <span className="preview-text preview-bottom">{text1}</span>}
                    </div>
                    <button
                      type="button"
                      className="load-more-button"
                      onClick={this.generate}
                      disabled={creating}
                    >
                      {creating ? "Generating…" : "Generate Meme"}
                    </button>
                    {error && <p className="text-danger mt-2 mb-0">Failed to generate, try again.</p>}
                  </>
                ) : (
                  <p className="text-muted mb-0">Your preview will appear here.</p>
                )}
              </Card.Body>
            </Card>
            </div>
          </Col>
        </Row>

        <Row>
          <Col>
            <Card className="created-memes-card">
              <Card.Body>
                <Card.Title>Your Created Memes</Card.Title>
                <MyMemes />
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    );
  }
}

function mapStateToProps(state) {
  return state;
}

export default connect(mapStateToProps, { createMeme })(App);